import { render, staticRenderFns } from "./wjx_create.vue?vue&type=template&id=02c03b55&scoped=true"
import script from "./wjx_create.vue?vue&type=script&lang=js"
export * from "./wjx_create.vue?vue&type=script&lang=js"
import style0 from "./wjx_create.vue?vue&type=style&index=0&id=02c03b55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c03b55",
  null
  
)

export default component.exports